import classNames from 'classnames'
import Button from 'component_library/1_Atoms/Button'
import styles from './index.module.scss'

type ShowHideMapButtonProps = {
  shouldMapLoad: boolean
  handleOnClick: () => void
  className?: string
}

const ShowHideMapButton: React.FC<ShowHideMapButtonProps> = ({
  shouldMapLoad,
  handleOnClick,
  className,
}) => (
  <Button
    variant="navy"
    className={classNames(styles.loadMapButton_button, className)}
    onClick={handleOnClick}
  >
    <img
      src="/icons/MapTrifold.svg"
      alt="show/hide map"
      width={26}
      height={26}
      className={styles.loadMapButton_icon}
    />
    {shouldMapLoad ? 'Hide Map' : 'Show Map'}
  </Button>
)

export default ShowHideMapButton
